var render = function render(){
  var _vm$maintenanceDetail, _vm$maintenanceDetail2, _vm$maintenanceDetail3, _vm$maintenanceDetail4, _vm$maintenanceDetail5, _vm$maintenanceDetail6, _vm$maintenanceDetail7, _vm$maintenanceDetail8;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "m-4 bg-white",
    staticStyle: {
      "border-radius": "12px"
    }
  }, [_vm.maintenanceDetailData ? _c('b-row', {
    staticClass: "p-4"
  }, [_vm.stateAction === 'VIEW_DETAIL' ? _c('b-col', {
    staticClass: "text-right",
    attrs: {
      "cols": "12"
    }
  }) : _vm._e(), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-row', [_c('b-col', {
    staticClass: "mb-4",
    attrs: {
      "md": _vm.action == 'VIEW_DETAIL' ? 12 : 6
    }
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('div', {
    staticClass: "w-50 p-5 text-center"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": (_vm$maintenanceDetail = (_vm$maintenanceDetail2 = _vm.maintenanceDetailData.vehicle) === null || _vm$maintenanceDetail2 === void 0 ? void 0 : (_vm$maintenanceDetail3 = _vm$maintenanceDetail2.vehicleType) === null || _vm$maintenanceDetail3 === void 0 ? void 0 : (_vm$maintenanceDetail4 = _vm$maintenanceDetail3.icon) === null || _vm$maintenanceDetail4 === void 0 ? void 0 : _vm$maintenanceDetail4.url) !== null && _vm$maintenanceDetail !== void 0 ? _vm$maintenanceDetail : require('@src/assets/images/Km3FO09.png'),
      "alt": "images"
    }
  })]), _c('div', {
    staticClass: "w-50"
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "mr-2 mb-2"
  }, [_c('IconFleet')], 1), _c('div', {
    staticClass: "d-flex flex-column align-items-start"
  }, [_c('strong', {
    staticClass: "text-primary"
  }, [_vm._v(_vm._s(_vm.maintenanceDetailData.vehicle.name) + " 🇮🇩")]), _c('span', [_vm._v(_vm._s(_vm.maintenanceDetailData.vehicle.company.company))])])]), _c('div', {
    staticClass: "d-flex"
  }, [_c('table', {
    staticClass: "table table-striped",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("Fleet Type")]), _c('td', [_vm._v(_vm._s((_vm$maintenanceDetail5 = _vm.maintenanceDetailData.vehicle) === null || _vm$maintenanceDetail5 === void 0 ? void 0 : (_vm$maintenanceDetail6 = _vm$maintenanceDetail5.vehicleType) === null || _vm$maintenanceDetail6 === void 0 ? void 0 : _vm$maintenanceDetail6.name))])]), _c('tr', [_c('td', [_vm._v("Call Sign")]), _c('td', [_vm._v("-")])]), _c('tr', [_c('td', [_vm._v("Year & Building")]), _c('td', [_vm._v(_vm._s((_vm$maintenanceDetail7 = _vm.maintenanceDetailData) === null || _vm$maintenanceDetail7 === void 0 ? void 0 : _vm$maintenanceDetail7.vehicle.yearBuildCountry) + " / " + _vm._s((_vm$maintenanceDetail8 = _vm.maintenanceDetailData) === null || _vm$maintenanceDetail8 === void 0 ? void 0 : _vm$maintenanceDetail8.vehicle.flag))])])])])])])]), _vm.action !== 'VIEW_DETAIL' ? _c('div', {
    staticClass: "d-flex flex-column"
  }, [_c('CustomNav', {
    staticClass: "mb-3",
    attrs: {
      "items": _vm.navItems
    },
    on: {
      "item-click": function itemClick(val) {
        return _vm.viewMenu1 = val;
      }
    }
  }), _c('b-row', [_vm.viewMenu1 === 'rh' ? _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('MaintenanceRhList', {
    attrs: {
      "maintenanceDetailData": _vm.maintenanceDetailData
    }
  })], 1) : _vm._e(), _vm.viewMenu1 === 'mi' ? _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('MaintenanceInfoList', {
    attrs: {
      "maintenanceDetailData": _vm.maintenanceDetailData
    },
    on: {
      "handleOpenFilePreview": _vm.handleOpenFilePreview
    }
  })], 1) : _vm._e(), _vm.viewMenu1 === 'ei' ? _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('MaintenanceInitInfo', {
    attrs: {
      "maintenanceDetailData": _vm.maintenanceDetailData
    }
  })], 1) : _vm._e()], 1)], 1) : _vm._e()]), _c('b-col', {
    staticClass: "mb-4",
    attrs: {
      "md": _vm.action == 'VIEW_DETAIL' ? 12 : 6
    }
  }, [_c('CustomNav', {
    staticClass: "mb-3",
    attrs: {
      "items": _vm.navItems2
    },
    on: {
      "item-click": function itemClick(val) {
        return _vm.viewMenu2 = val;
      }
    }
  }), _c('b-row', [_vm.viewMenu2 === 'mp' ? _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [['ON_MAINTENANCE', 'ON_POSTPONE', 'ON_CONVERT'].includes(_vm.stateAction) && !_vm.isEdit ? [_vm.stateAction === 'ON_MAINTENANCE' ? [_c('OnMaintenanceForm', {
    attrs: {
      "maintenanceDetailData": _vm.maintenanceDetailData
    },
    on: {
      "submitForm": _vm.saveMaintenance,
      "uploadFile": _vm.uploadFile
    },
    model: {
      value: _vm.formMaintenance,
      callback: function callback($$v) {
        _vm.formMaintenance = $$v;
      },
      expression: "formMaintenance"
    }
  })] : _vm.stateAction === 'ON_POSTPONE' ? _c('b-row', [_vm.maintenanceDetailData.trigger === 'COUNTER' ? _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Extra Hours *"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.formPostpone.extraHours,
      expression: "formPostpone.extraHours"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.formPostpone.extraHours
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.formPostpone, "extraHours", $event.target.value);
      }
    }
  })])], 1) : _vm._e(), _vm.maintenanceDetailData.trigger === 'CALENDAR' ? _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Extra Date *"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.formPostpone.extraDate,
      expression: "formPostpone.extraDate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": _vm.formPostpone.extraDate
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.formPostpone, "extraDate", $event.target.value);
      }
    }
  })])], 1) : _vm._e(), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Reason *"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "rows": "3",
      "placeholder": "Type Reason"
    },
    model: {
      value: _vm.formPostpone.reason,
      callback: function callback($$v) {
        _vm.$set(_vm.formPostpone, "reason", $$v);
      },
      expression: "formPostpone.reason"
    }
  })], 1)], 1), _c('b-col', {
    staticClass: "text-center",
    attrs: {
      "md": "6"
    }
  }, [_c('button', {
    staticClass: "btn btn-outline-primary w-100",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.onAction('VIEW_DETAIL');
      }
    }
  }, [_vm._v("Cancel")])]), _c('b-col', {
    staticClass: "text-center",
    attrs: {
      "md": "6"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary w-100",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.savePostpone();
      }
    }
  }, [_vm._v("Submit")])])], 1) : _vm._e()] : _vm._e(), ['REVIEW', 'APPROVE'].includes(_vm.maintenanceDetailData.status) ? [_vm.isEdit ? _c('b-row', [_c('b-col', {
    staticClass: "text-center",
    attrs: {
      "md": "6"
    }
  }, [_c('button', {
    staticClass: "btn btn-outline-primary w-100",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.onAction('VIEW_DETAIL');
      }
    }
  }, [_vm._v("Cancel")])]), _c('b-col', {
    staticClass: "text-center",
    attrs: {
      "md": "6"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary w-100",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.editDoMaintenance();
      }
    }
  }, [_vm._v("Save Update")])])], 1) : _vm._e()] : _vm._e(), _vm.action == 'VIEW_DETAIL' || _vm.action == 'ON_REVIEW' || _vm.action == 'ON_APPROVE' ? [_c('MaintenanceInfoDetail', {
    attrs: {
      "maintenanceDetailData": _vm.maintenanceDetailData
    },
    on: {
      "handleOpenFilePreview": _vm.handleOpenFilePreview
    }
  })] : _vm._e()], 2) : _vm._e(), _vm.viewMenu2 === 'lh' ? _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('div', {
    staticClass: "overflow-auto d-flex w-100",
    staticStyle: {
      "max-height": "400px"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [_c('div', {
    staticClass: "p-3 px-3"
  }, [_c('LogsTemplate', {
    attrs: {
      "logs": _vm.maintenanceDetailData.logs
    }
  })], 1)])], 1)], 1)]) : _vm._e(), _vm.viewMenu2 === 'com' ? _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('MaintenanceCommentForm', {
    attrs: {
      "maintenanceId": _vm.maintenanceId,
      "maintenanceDetailData": _vm.maintenanceDetailData
    },
    on: {
      "refetch": function refetch() {
        return _vm.fetchMaintenanceDetail(_vm.maintenanceId);
      }
    }
  })], 1) : _vm._e(), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_vm.action == 'ON_REVIEW' || _vm.action == 'ON_APPROVE' ? _c('b-row', [_c('b-col', {
    staticClass: "text-center",
    attrs: {
      "md": "6"
    }
  }, [_c('button', {
    staticClass: "btn btn-outline-primary w-100",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('close');
      }
    }
  }, [_vm._v("Cancel")])]), _c('b-col', {
    staticClass: "text-center",
    attrs: {
      "md": "6"
    }
  }, [_vm.action == 'ON_REVIEW' ? _c('button', {
    staticClass: "btn btn-primary w-100",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('onReview', _vm.maintenanceId);
      }
    }
  }, [_vm._v("Review")]) : _vm._e(), _vm.action == 'ON_APPROVE' ? _c('button', {
    staticClass: "btn btn-primary w-100",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('onApprove', _vm.maintenanceId);
      }
    }
  }, [_vm._v("Approve")]) : _vm._e()])], 1) : _vm._e()], 1)], 1)], 1), _c('b-col', {
    staticClass: "mb-4",
    attrs: {
      "md": "6"
    }
  })], 1)], 1)], 1) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }